export const numberToCurrency = (type, number) => {
  return new Intl.NumberFormat('us-US', { style: 'currency', currency: type }).format(number)
}

export const numberToCurrencyWithoutSymbol = (number) => {
  return new Intl.NumberFormat('us-US').format(number)
}
